import { Injectable, Type } from '@angular/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { map, of, Subject, switchMap, timer } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SplitModalService {

  public action: string = '';

  protected listModel: any[] = [];
  protected activeModel!: DynamicDialogRef;

  public onClose: Subject<this> = new Subject();

  //onClose(): void {}

  constructor(public dialogService: DialogService) { }

  public push<T>(component: Type<T>, config: DynamicDialogConfig) {
    this.listModel.push({component, config});
    return this.create(component, config);
  }

  public pop() {
    if(this.listModel.length > 0) {
      this.listModel.pop();
      let model = this.listModel[this.listModel.length - 1];
      return this.create(model.component, model.config);
    }
    return;
  }

  public create(component: Type<any>, config: DynamicDialogConfig) {
    return of(this.activeModel).pipe(
      switchMap((value: any) => {
        if(value) {
          this.activeModel.close("pushPopOnClose");
          return timer(200);
        }
        return of(null);
      }),
      map(() => {
        let dialog = this.dialogService.open(component, 
          {
            width: '70%',
            style: {
              'height': 'auto',
              'max-height': '98vh'
            },
            baseZIndex: 10000,
            dismissableMask: false,
            ...config
          }
        );
        this.activeModel = dialog;
        dialog.onClose.subscribe((ref) => {
          if(ref != "pushPopOnClose") {
            this.onClose.next(this);
          }
        })
        return this;
    })
    )
  }

  public changeHeader( header: string, position: number = 0 ) {
    document.getElementsByClassName('p-dialog-title')[position].innerHTML = header
  }

  public calledfor(action: string) {
    this.action = action
  }



}
